import { T3 } from 'ia-react-core';
import React, { FC, ReactNode } from 'react';
import { StyledDiv } from './FormSection.styles';

export interface FormSectionProps {
  pt?: number;
  pb?: number;
  title?: string;
  children: ReactNode;
}

const FormSection: FC<FormSectionProps> = ({ pt = 36, pb = 0, title, children }) => (
  <StyledDiv pt={pt} pb={pb}>
    {title && <T3>{title}</T3>}
    {children}
  </StyledDiv>
);

export default FormSection;
